import React from 'react';

import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

import { StyledTextButton } from './text-button.styled';
import { TTextButtonProps } from './text-button.types';

export const TextButton: React.FC<TTextButtonProps> = ({
  variant,
  icon,
  tooltip,
  children,
  ...props
}) => {
  return (
    <Tooltip title={tooltip} wrapper="default">
      <StyledTextButton $variant={variant} {...props}>
        {icon}
        {children}
      </StyledTextButton>
    </Tooltip>
  );
};
